<template>
    <div class="my-4">
        <div class="flex flex-col justify-between items-start">
            <h1 class="text-3xl">
                Colecciones
                <strong class="text-theme-primary">destacadas</strong>
            </h1>
            <small class="text-theme-muted mt-4">
                Selecciona la categoría y consulta para gestionar el orden
                destacado
            </small>
        </div>

        <div class="mt-6 p-4 rounded-lg border border-brand-blue">
            <p class="text-sm text-theme-muted mb-3">Filtrar por categoría</p>
            <line-selector v-model="line" add-root enabled />
            <div class="flex justify-end mt-4">
                <app-button relief @click="listHighlightCollectionsComponent">
                    Consultar 🔎
                </app-button>
            </div>
        </div>

        <template v-if="isQuery">
            <div class="mt-6">
                <div class="flex items-center justify-between mb-3">
                    <h3 class="text-lg">Agregar colecciones al destacado</h3>
                    <span v-if="items.length" class="text-sm text-theme-muted">
                        {{ items.length }} colección{{
                            items.length !== 1 ? "s" : ""
                        }}
                        seleccionada{{ items.length !== 1 ? "s" : "" }}
                    </span>
                </div>
                <collections-search
                    v-model="lastCollectionSelected"
                    @input="validatePushItems"
                />
            </div>

            <div class="mt-4">
                <items-cards v-model="items" entity="collections" />
                <div
                    v-if="!items.length"
                    class="mt-4 py-10 text-center text-theme-muted"
                >
                    Sin colecciones destacadas. Usa el buscador para agregar.
                </div>
                <div class="flex justify-end mt-4 mb-6">
                    <app-button
                        color="success"
                        @click="updateHighlightCollectionsComponent"
                    >
                        Guardar cambios ✔
                    </app-button>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import CollectionsSearch from "@/components/collections/CollectionsSearch.vue";
import LineSelector from "@/components/lines/LineSelector.vue";
import ItemsCards from "@/components/utils/ItemsCards.vue";

export default {
    name: "HighlightCollections",
    components: {
        LineSelector,
        ItemsCards,
        CollectionsSearch
    },
    data: () => ({
        isLoading: true,
        items: [],
        isQuery: false,
        lastCollectionSelected: { name: "" },
        line: {
            slug: null,
            name: ""
        }
    }),
    computed: { ...mapGetters("control", ["backgroundColor"]) },
    async mounted() {
        const verifyPagePermission =
            this.$ability.verifyPagePermission.bind(this);
        await verifyPagePermission("collection:ListHighlight", "/app");
    },
    methods: {
        ...mapActions("collections", [
            "listHighlightCollections",
            "updateHighlightCollections"
        ]),
        async listHighlightCollectionsComponent() {
            this.isLoading = true;
            this.$loading.show();
            try {
                this.items = await this.listHighlightCollections({
                    lineSlug: this.line.slug ?? null
                });
                this.isQuery = true;
                this.$loading.hide();
            } catch (error) {
                this.$loading.hide();
                this.isLoading = false;
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        async updateHighlightCollectionsComponent() {
            this.isLoading = true;
            this.$loading.show();
            try {
                await this.updateHighlightCollections({
                    lineSlug: this.line?.slug ?? null,
                    collectionsSlugs: this.items.map((item) => item.slug)
                });
                this.$sound.play();
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Actualización exitosa",
                    icon: "success",
                    showCloseButton: true,
                    timer: 3000
                });
                this.$loading.hide();
            } catch (error) {
                this.$loading.hide();
                this.isLoading = false;
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        validatePushItems(newItem) {
            const index = this.items.findIndex(
                (item) => newItem.slug === item.slug
            );
            if (index === -1) {
                this.items.unshift(newItem);
            }
        }
    }
};
</script>
